import { withClientErrorPage } from '@sm/webassets';
import FiveHundredError from './FiveHundredError';

export default withClientErrorPage(FiveHundredError, { titularElementTag: 'h1' });
